import styles from "../styles/PageToggle.module.css";
import { useState, useEffect } from "react";

function PageToggle({
  options,
  handleSelect,
  width,
  label,
  flexDir,
  required,
}) {
  // handle small screens with react inline styles
  const mediaMatch = window.matchMedia("(max-width: 550px");
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addEventListener("change", handler);
    return () => mediaMatch.removeEventListener("change", handler);
  }, [matches]); // eslint-disable-line react-hooks/exhaustive-deps

  const directionToFlex = matches
    ? "column"
    : flexDir === "row"
    ? "row"
    : "column";
  const rowStyle = {
    display: "flex",
    flexDirection: directionToFlex,
    justifyContent: "left",
    alignItems: "left",
  };

  return (
    <div
      className={styles.container}
      style={matches ? rowStyle : { flexDirection: flexDir }}
    >
      <span
        className={`${required && "required-field-before"} ${styles.label}`}
      >
        {label}
      </span>
      <div className={styles.toggleContainer}>
        {options.map((option, index) => {
          return (
            <button
              key={index}
              type="button"
              aria-label={`the option is ${option.label} and it is ${
                option.selected ? "selected" : "not selected"
              }`}
              className={`noselect ${styles.toggleBase} ${
                option.selected && styles.selected
              }`}
              onClick={() => handleSelect(option.label)}
              style={{ width: width, minWidth: "fit-content" }}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default PageToggle;
